const request = require('request');
const config = require('./config');

var getProdutos = (token,filters) => {
    return new Promise((resolve,reject) => {
        request({
            headers: {
              'Content-Type': 'application/json',
              'User-Token': token
            },
            uri: config.URL_BACKEND+'/produtos',
            method: 'GET',
            qs: filters
          }, (err, res, body) => {
            if (err) return reject(err);
            resolve(body)
          })
    })
}

module.exports = {
  getProdutos:getProdutos
}